import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import * as ScreenOrientation from 'expo-screen-orientation';
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';

const BarCodeConfirmPay = () => {
    const navigation = useNavigation();
    const [barCode, setBarCode] = useState('');

    async function goBack(){
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE_RIGHT);
        navigation.goBack();
    }

    return (
        <>
            <View style={styles.containerHeader}>
            <View style={styles.contentHeader}>
                <MaterialIcons
                    name="keyboard-arrow-left"
                    size={30}
                    color="#fff"
                    style={styles.iconsHeader}
                    onPress={goBack}
                />

                <Text style={styles.titleHeader}>Código de barras</Text>
            </View>
        </View>

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <InputDefault
                        value={barCode}
                        onValueChange={(value) => setBarCode(value)}
                        placeholder={"Código de barras"}
                    />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do pagamento:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX TOKEN</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>XXX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONFIRMAR"} titlePage={"Confirmar pagamento"} />
        </>
    );
}

export default BarCodeConfirmPay;